import { Platform } from "react-native";
import { AppState } from "../rootReducer";

export const getIsConnected = (state: AppState) => Platform.OS === "web" ? Platform.OS === "web" : state.network.isConnected;